import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useNotices = (limit?: number) => {
  return useQuery({
    queryKey: ["notices", limit],
    queryFn: async () => {
      let query = supabase
        .from("notices")
        .select("*")
        .eq("is_published", true)
        .order("priority", { ascending: false })
        .order("created_at", { ascending: false });

      if (limit) {
        query = query.limit(limit);
      }

      const { data, error } = await query;

      if (error) {
        throw error;
      }

      return data || [];
    },
  });
};